queryRefs